import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AgentDetail from './components/AgentDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAgent',
  components: {
    AgentDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;